import List from '@nichoth/state/list';

var MiscAssets = List.extend({
    idKey: 'assetID',
    sortBy: 'assetID'
})

export default MiscAssets;
